<template>
  <basic-card :style="{ overflowY: 'hidden' }">
    <div class="dataStastisticsAddTable-base-info">
      <div class="info-title">{{ Lang.label.baseInfo }}</div>
      <div class="table-name">
        <div class="label">{{ Lang.label.reportName}}：</div>
        <span class="red">*</span>
        <el-input class="input" required clearable v-model="tableName" :placeholder="Lang.tips.plzInput"></el-input>
      </div>
    </div>
    
    <avue-crud
      :option="option"
      v-model:search="search"
      :table-loading="loading"
      :data="tableData"
      ref="crud"
      v-model="form"
      :permission="permissionObj"
      @row-del="rowDel"
      @row-update="rowUpdate"
      @row-save="rowSave"
      :before-open="beforeOpen"
      v-model:page="page"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoad"
    >
      <template #menu-left>
        <div class="info-title">{{ Lang.label.analysisData }}</div>
      </template>
      <template #menu-right>
        <comp-button type="primary" v-if="permissionObj.add" @click="handleAddData">{{ Lang.btn.add }}</comp-button>
      </template>
      <template #menu="scope">
        <div class="operation-btns">
          <CompIconButton :auth="permissionObj" type="delete" :divider="false" @click="handleDel(scope.row)" > </CompIconButton>
        </div>
      </template>
    </avue-crud>
    <!-- addData 页面 -->
    <el-drawer 
      custom-class="add-data-page-drawer"
      body-class="add-data-page-drawer-body"
      header-class="add-data-page-drawer-header"
      :title="Lang.label.addData"
      append-to-body
      v-model="addDataDialog"
      size="80%">
      <addData @selectChange="handleSelectChange"></addData>
    </el-drawer>
    <div class="dataStastisticsAddTable-submit-row">
      <el-button type="primary" @click="handleSaveTable">{{ Lang.btn.save }}</el-button>
    </div>
  </basic-card>
</template>

<script>
import { 
  getProjectTree,
  add,
  remove,
  update,
  getDeptLazyTree,
  getDetail,
 } from '@/api/project/project';

import {
  reportSubmit,
  removeReportModuleItem,
  getReportDataDetail,
} from '@/api/energyManage/reportData'

import { getDeptTree } from '@/api/system/dept';
import { getLazyTree } from '@/api/base/region';
import { mapGetters } from 'vuex';
import website from '@/config/website';
import 'nprogress/nprogress.css';
import func from '@/utils/func';
import compTabs from '@/components/comp-tab/index.vue';
import addData from './dataStastisticsAddTableData.vue';
import { deepClone } from '@/utils/util';

export default {
  components: {
    compTabs,
    addData
  },
  props: {
    groupId: { // 分类ID
      type: String,
      default: ''
    },
    reportId: { // 编辑报表ID
      type: String,
      default: ''
    },
    operationType: {
      type: String,
      default: 'add'
    },
  },
  data() {
    return {
      pageArea: '',
      tableName: '',
      form: {},
      search: {},
      roleBox: false,
      addDataDialog: false,
      excelBox: false,
      platformBox: false,
      initFlag: true,
      auditMode: false,
      selectionList: [],
      searchOptions: [
        {label: this.Lang.label.name, value: '1', searchKey: 'name'},
      ],
      query: {},
      loading: true,
      platformLoading: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      platformPage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      init: {
        roleTree: [],
        deptTree: [],
      },
      props: {
        label: 'title',
        value: 'key',
      },
      roleGrantList: [],
      roleTreeObj: [],
      treeDeptId: '',
      treeData: [],
      treeOption: {
        nodeKey: 'id',
        lazy: false,
        treeLoad: function (node, resolve) {
          const parentId = node.rank === 1 ? '00' : node.data.parentId;
          const params = {
            parentId,
          }
          getProjectTree(params).then(res => {
            resolve(
              res.data.data.map(item => {
                return {
                  ...item,
                  leaf: !item.childTreeList,
                };
              })
            );
          });
        },
        addBtn: false,
        menu: false,
        size: 'small',
        props: {
          labelText: this.Lang.tips.title,
          label: 'name',
          value: 'code',
          children: 'childTreeList',
        },
      },
      option: {
        height: 'auto',
        calcHeight: 'auto', // 表格的高度增加量，默认为自动高度。如果设置为auto，会自适应窗口高度。
        tip: false,
        searchShow: true, // 搜索栏
        searchMenuSpan: 6,
        gutter: 12,
        border: false, // 每行的竖线
        index: true,
        indexLabel: this.Lang.table.serialNumber,
        indexWidth: '100%',
        selection: false, // 选择
        menuWidth: 100, // 操作列宽
        addBtn: false, // 添加
        viewBtn: false, // 查看
        editBtn: false, // 编辑
        delBtn: false, // 删除
        menuType: 'button',
        menuTitle: this.Lang.label.operation,
        menuHeaderAlign: 'right', // 操作按钮样式
        menuLabelClassName: '',
        dialogType: 'drawer', // dialog drawer
        dialogClickModal: false,
        dialogMenuPosition: 'center', // 弹窗按钮位置
        // updateBtnText: '修改',
        emptyBtn: true,
        emptyBtnText: this.Lang.btn.empty,
        column: [ // 表格列
          {
            label: this.Lang.table.deviceName,
            prop: 'rtuName',
            search: false,
            slot: false, // 自定义内容格式化
            display: false,
          },
          {
            label: this.Lang.table.deviceId,
            prop: 'rtuId',
            search: false,
            display: false,
          },
          {
            label: this.Lang.table.itemName,
            prop: 'name',
            search: false,
            display: false,
          },
          {
            label: this.Lang.table.dataItemId,
            prop: 'id',
            search: false,
            display: false,
          },
          {
            label: this.Lang.label.unit,
            prop: 'unit',
            search: false,
            display: false,
          },
        ],
        group: [ // 新增弹出的form及校验
          {
            label: this.Lang.label.projectInfo,
            prop: 'projectInfo',
            labelPosition: 'top',
            labelTipPlacement: 'top-start',
            labelWidth: '120px',
            column: [
              {
                label: this.Lang.label.projectName,
                prop: 'name',
                rules: [
                  {
                    required: false,
                    message: this.Lang.tips.inputProjectName,
                    trigger: 'blur',
                  },
                ],
                span: 12,
              },
              {
                label: this.Lang.label.areaSelect,
                prop: 'region',
                type: 'tree',
                lazy: true,
                // dicUrl: '/blade-system/region/lazy-tree',
                // collapseTags: true,
                leafOnly: false,
                props: {
                  label: 'title',
                  value: 'codes',
                },
                treeLoad: function (node, resolve) {
                  const parentCode = node.level === 0 ? '00' : node.data.id;
                  getLazyTree(parentCode).then(res => {
                    resolve(
                      res.data.data.map(item => {
                        return {
                          ...item,
                          leaf: !item.hasChildren,
                        };
                      })
                    );
                  });
                },
                change: ({column, value}) => {
                  console.log(column, value);
                },
                // nodeClick: (nodeObj, currentNode, node) => {
                // },
                hide: !website.tenantMode,
                addDisplay: website.tenantMode,
                editDisplay: website.tenantMode,
                viewDisplay: website.tenantMode,
                rules: [
                  {
                    required: false,
                    message: this.Lang.tips.plzInputArea,
                    trigger: 'click',
                  },
                ],
                span: 12,
              },
              {
                label: this.Lang.label.responseAddress,
                prop: 'address',
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                rules: [{ required: false, trigger: 'blur' }],
                span: 12,
              },
              {
                label: this.Lang.label.longitude,
                prop: 'lng',
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                rules: [{ required: false, trigger: 'blur' }],
                span: 6,
              },
              {
                label: this.Lang.label.latitude,
                prop: 'lat',
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                rules: [{ required: false, trigger: 'blur' }],
                span: 6,
              },
              {
                label: this.Lang.label.orgOf,
                type: 'select',
                // dicUrl: '/blade-system/dept/tree',
                props: {
                  label: 'title',
                  value: 'codes',
                },
                treeLoad: function (node, resolve) {
                  const parentId = node.level === 0 ? '00' : node.data.id;
                  getDeptLazyTree(parentId).then(res => {
                    resolve(
                      res.data.data.map(item => {
                        return {
                          ...item,
                          leaf: !item.hasChildren,
                        };
                      })
                    );
                  });
                },
                type: 'tree',
                lazy: true,
                dataType: 'string',
                // slot: true,
                prop: 'deptId',
                rules: [
                  {
                    required: false,
                    message: this.Lang.tips.plzSelectOrg,
                    trigger: 'blur',
                  },
                ],
                span: 12,
              },
            ],
          },
        ],
      },
      tableData: [],
      platformQuery: {},
      platformSelectionList: [],
      platformData: [],
      platformForm: {},
      platformOption: {
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        selection: true,
        viewBtn: true,
        dialogClickModal: false,
        menuWidth: 120,
        editBtnText: this.Lang.label.config,
        column: [
          {
            label: this.Lang.label.loginAccount,
            prop: 'account',
            search: true,
            display: false,
          },
          {
            label: this.Lang.label.tenantOf,
            prop: 'tenantName',
            slot: true,
            display: false,
          },
          {
            label: this.Lang.label.userName,
            prop: 'realName',
            search: true,
            display: false,
          },
          {
            label: this.Lang.label.userPlatform,
            prop: 'userTypeName',
            slot: true,
            display: false,
          },
          {
            label: this.Lang.label.userPlatform,
            type: 'select',
            dicUrl: '/blade-system/dict/dictionary?code=user_type',
            props: {
              label: 'i18nValue',
              value: 'dictKey',
            },
            dataType: 'number',
            search: true,
            hide: true,
            display: false,
            prop: 'userType',
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzSelectUserPlatform,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.label.userExtend,
            prop: 'userExt',
            type: 'textarea',
            minRows: 8,
            span: 24,
            overHidden: true,
            row: true,
            hide: true,
          },
        ],
      },
      excelForm: {},
      excelOption: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: this.Lang.tips.templateUpload,
            prop: 'excelFile',
            type: 'upload',
            drag: true,
            loadText: this.Lang.tips.templateUploadingPlzWait,
            span: 24,
            propsHttp: {
              res: 'data',
            },
            tip: this.Lang.tips.plzUploadStandarFile,
            action: '/blade-system/user/import-user',
          },
          {
            label: this.Lang.tips.dataCover,
            prop: 'isCovered',
            type: 'switch',
            align: 'center',
            width: 80,
            dicData: [
              {
                label: this.Lang.label.no,
                value: 0,
              },
              {
                label: this.Lang.label.yes,
                value: 1,
              },
            ],
            value: 0,
            slot: true,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzSelectIfCover,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.tips.templateDownload,
            prop: 'excelTemplate',
            formslot: true,
            span: 24,
          },
        ],
      },
    };
  },
  watch: {
    'form.tenantId'() {
      if (this.form.tenantId !== '' && this.initFlag) {
        this.initData(this.form.tenantId);
      }
    },
    'excelForm.isCovered'() {
      if (this.excelForm.isCovered !== '') {
        const column = this.findObject(this.excelOption.column, 'excelFile');
        column.action = `/blade-system/user/import-user?isCovered=${this.excelForm.isCovered}`;
      }
    },
  },
  computed: {
    ...mapGetters(['menuItem', 'permission']),
    permissionObj() {
      const keys = Object.keys(this.permission)
      const obj = {}
      const menuId = this.menuItem.id;
      keys.forEach((key => {
        if (key.indexOf(menuId) > -1) {
          const btnType = key.substr(menuId.length);
          obj[btnType] = true;
        }
      }))
      return obj
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  mounted() {
    // 非租户模式默认加载管理组数据
    if (!website.tenantMode) {
      this.initData(website.tenantId);
    }
    this.getTreeData();
    this.initData();
  },
  methods: {
    // 自定义删除
    handleDel(row) {
      this.$refs.crud.rowDel(row);
    },
    // 获取左侧树
    getTreeData() {
      const params = {
        parentId: '00',
      }
      getProjectTree(params).then(res => {
        const treeData = res.data.data;
        this.treeData = treeData;
      });
    },
    // 新增或者修改共用保存按钮
    handleSaveTable() {
      if (!this.tableName) {
        return this.$message.error('输入报表名称');
      }
      const reportModuleItemList = [];
      this.tableData.map(item => {
        reportModuleItemList.push({
          // id: item.id,
          tenantId: item.tenantId,
          reportId: item.reportId,
          itemId: item.id,
          itemName: item.name,
          calcrule: item.calcrule,
          sort: item.sort,
          rtuId: item.rtuId,
          rtuName: item.name,
        })
      })
      const params = {
        name: this.tableName,
        groupId: this.groupId,
        id: this.reportId, // 编辑时有报表Id
        reportModuleItemList,
      }
      reportSubmit(params).then(res => {
        this.$message({
          type: 'success',
          message: this.Lang.tips.operationSuccess,
        });
        this.$emit('success')
      })
    },
    handleSelectChange(list) {
      // 没有才添加
      const newList = []
      const oldList = deepClone(this.tableData);
      list.forEach(item => {
        const isExist = oldList.find(ele => ele.id === item.id);
        if (!isExist) {
          newList.push(item)
        }
      })
      this.tableData = [...oldList, ...newList];
      this.addDataDialog = false;
    },
    handleAddData() {
      this.addDataDialog = true;
    },
    // 添加数据
    handleAddProject() {
      this.$refs.crud.rowAdd();
    },
    nodeClick(data) {
      this.pageArea = data.name;
      this.treeDeptId = data.id;
      this.page.currentPage = 1;
      this.onLoad(this.page);
    },
    initData(tenantId) {
      // 获取所属机构编辑查看回显
      getDeptTree(tenantId).then(res => {
        const column = this.findObject(this.option.group, 'deptId');
        column.dicData = res.data.data;
      });
      getLazyTree(tenantId).then(res => {
        const column = this.findObject(this.option.group, 'region');
        column.dicData = res.data.data;
      });
    },
    rowSave(row, done, loading) {
      row.deptId = func.join(row.deptId);
      row.roleId = func.join(row.roleId);
      row.postId = func.join(row.postId);
      add(row).then(
        () => {
          this.initFlag = false;
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      row.deptId = func.join(row.deptId);
      row.roleId = func.join(row.roleId);
      row.postId = func.join(row.postId);
      update(row).then(
        () => {
          this.initFlag = false;
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          if (row.originId) { // 新加的没有这个ID
            return removeReportModuleItem(row.originId);
          } else {
            this.tableData.splice(row.$index, 1);
          }
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
    },
    searchReset() {
      this.query = {};
      this.treeDeptId = '';
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail(this.form.id).then(res => {
          // this.defaultCheckedKeys = [];
          this.form = res.data.data;
          // if (this.form.region) {
          //   const list = this.form.region.split(',');
          //   this.$refs.crud.option.group[0].column.filter(item => {
          //     if (item.prop === 'region') {
          //       item.defaultExpandedKeys = list;
          //       item.defaultCheckedKeys = list;
          //     }
          //   });
          // }
          if (this.form.hasOwnProperty('deptId')) {
            this.form.deptId = func.split(this.form.deptId);
          }
          if (this.form.hasOwnProperty('roleId')) {
            this.form.roleId = func.split(this.form.roleId);
          }
          if (this.form.hasOwnProperty('postId')) {
            this.form.postId = func.split(this.form.postId);
          }
        });
      }
      this.initFlag = true;
      done();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page, params = {}) {
      if (!this.reportId || this.operationType !== 'edit') {
        this.loading = false;
        return;
      }
      this.loading = true;
      getReportDataDetail({id: this.reportId}).then(res => {
        const data = res.data.data;
        this.page.total = data.total;
        const list = data.reportModuleItemList || [];
        // this.reportId = data.id;
        // this.groupId = data.groupId,
        list.forEach(item => {
          item.originId = item.id;
          item.id = item.itemId;
          item.name = item.itemName;
        })
        this.tableData = list;
        this.tableName = data.name;
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>

.operation {
  display: flex;
}
.el-form-item__label {
  justify-content: flex-start;
}
.el-tree-node__label {
  display: flex;
  align-items: center;
}


</style>
